import React, { Component } from 'react'

import StatTabs from './StatTabs'
import TotalEnrolled from './TotalEnrolled'
import CampaignTotalEnrolled from './CampaignTotalEnrolled'
import TotalClicks from './TotalClicks'
import CampaignTotalClicks from './CampaignTotalClicks'
import TotalLoss from './TotalLoss'
import CampaignTotalLoss from './CampaignTotalLoss'
import TotalConversations from './TotalConversations'
import CampaignTotalConversations from './CampaignTotalConversations'
import TotalDollars from './TotalDollars'
import ClickMap from './ClickMap'
import { Div } from '@driftt/tide-core'
import { pathOr } from 'ramda'
import './styles.css'

const getTopSections = (isCampaign) => (
  {
    'TOTAL_ENROLLED': isCampaign ? CampaignTotalEnrolled: TotalEnrolled,
    'TOTAL_CLICKS': isCampaign ? CampaignTotalClicks: TotalClicks,
    'TOTAL_LOSS': isCampaign ? CampaignTotalLoss: TotalLoss,
    'TOTAL_CONVERSATIONS': isCampaign ? CampaignTotalConversations: TotalConversations,
    'TOTAL_DOLLARS': TotalDollars
  }
)

class EmailPerformance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeSection: 'TOTAL_CLICKS'
    }
  }

  switchActive = (tab) => {
    this.setState({activeSection: tab})
  }


  formatDataForClickmap = (clickMapData) => {
    return this.props.playbook && this.props.playbook.actions[0].action.signatureActions
      .filter(action => action.hasCampaignGraphic)
      .map(action => {
        return {
          ...clickMapData[action.id],
          ...action
        }
      })
  }


  render() {
    const { activeSection } = this.state
    const { data, playbook, dateRanges, salesForceRevenue, totalSFRevenue, playbookReportType, clickMapData, sfError, campaign } = this.props
    const isCampaign = !!campaign
    const StatsArea = getTopSections(isCampaign)[activeSection]
    const isSignaturePlaybook = playbookReportType === 'signature'

    const salesDollars = totalSFRevenue ? totalSFRevenue.total.CLOSED_WON.value : null
    return (
      <Div className="email-performance-container">
      {!!data &&
        <Div>
          <StatTabs
            data={data}
            activeTab={activeSection}
            switchTab={this.switchActive}
            reportType={pathOr(null, ['reportType'], playbook)}
            isCampaign={isCampaign}
            playbookReportType={playbookReportType}
            salesForceRevenue={salesForceRevenue}
            totalSalesForceDollars={salesDollars}/>
          <Div className="email-performance--stats-container">
            <StatsArea
              data={data}
              playbook={playbook}
              campaign={campaign}
              dateRanges={dateRanges}
              activeState={activeSection}
              totalSFRevenue={totalSFRevenue}
              sfError={sfError}
              salesForceRevenueActive={salesForceRevenue}
              playbookReportType={playbookReportType}
            />
          </Div>
          {isSignaturePlaybook && <ClickMap clickMapData={this.formatDataForClickmap(clickMapData)}/> }
        </Div>
      }
      </Div>
    )
  }
}

export default EmailPerformance
